import { useCallback } from "react";
import Constants from "../../Constants";
import { toaster, errorToast } from "../../utils/toast";
import useAxios from "../../hooks/useAxios";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../redux/actions/users";
import { userLimitReachedHtml } from "../../utils/constant";
import { confirm } from "../../utils/swal";
import useListPage from "../../hooks/useListPage";

const useUsers = () => {
    const { postData } = useAxios();
    const { subscription = {} } = useSelector((state) => state.users || {});
    const dispatch = useDispatch();
    const remainingUser = subscription?.remainingUser || 0;

    const onSuccess = useCallback((data) => dispatch(setUser({ subscription: data.subscription })), [dispatch]);

    const {
        list: usersList,
        selectedItem: selectedUserId,
        setIsShowModal,
        isFormSubmitting,
        setIsFormSubmitting,
        resetValue,
        refetch: fetchUsers,
        handleSearchChange,
        isLoading,
        handleEdit: handleEditBase,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal,
        closeModal,
    } = useListPage({ fetchUrl: Constants.ApiUrl.user.getUsers, responseKey: "users", onSuccess });

    // guard against missing _id before opening the edit modal
    const handleEdit = useCallback((user) => {
        if (!user?._id) {
            errorToast('Unable to edit user, please try again');
            return;
        }
        handleEditBase(user?._id);
    }, [handleEditBase]);

    const openAddUserModal = async () => {
        if (remainingUser <= 0) {
            const result = await confirm({ title: "Subscription Limit Reached", html: userLimitReachedHtml });
            if (!result.isConfirmed) return;
        }
        setIsShowModal(true);
    };

    const handleSubmitForm = async (url, formData) => {
        try {
            setIsFormSubmitting(true);
            const { success, message } = await postData(url, formData);
            if (success) {
                resetValue();
                toaster({ message, success });
                fetchUsers();
            } else {
                toaster({ message: message || "Request Failed Please Try Again Later", success: false });
            }
        } catch (error) {
            toaster({ message: error.message || "Request Failed Please Try Again Later", success: false });
        } finally {
            setIsFormSubmitting(false);
        }
    };

    const onSubmit = (formData) => {
        if (selectedUserId) {
            handleSubmitForm(Constants.ApiUrl.user.updateUser, { ...formData, _id: selectedUserId });
        } else {
            handleSubmitForm(Constants.ApiUrl.user.add, formData);
        }
    };

    return {
        handleSearchChange,
        openAddUserModal,
        isLoading,
        handleEdit,
        usersList,
        limit,
        setLimit,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        isShowModal,
        closeModal,
        onSubmit,
        isFormSubmitting,
        selectedUserId,
    };
};

export default useUsers;
